const getBaseUrl = () => {
  return "https://api.digibhakti.com/api/";
};
export { getBaseUrl };

const getBaseUrl2 = () => {
  return "https://api.digibhakti.com/";
};
export { getBaseUrl2 };
